module.exports = __webpack_public_path__ + "media/images/cursors/arrow_right-086669db80b3fd1a3a6144bb3314681b.svg";